import React from 'react';
import { ErrorMessage, FieldProps, FormikValues } from 'formik';
import { Field } from '~/components/Formik';
import { detailCollectionValidation } from '~/util';

interface ActionRadioProps {
    detail: QualityMeasureDetailType;
    gapCollection: QualityMeasureDetailType[];
    getName: (x: QualityMeasureDetailType) => null | string;
    checkboxId: string;
    formik: FormikValues;
    readOnly: boolean;
}
export function ActionRadio({
    detail,
    gapCollection,
    getName,
    checkboxId,
    readOnly,
    formik,
}: ActionRadioProps) {
    function validate(value: string) {
        if (!formik.values[checkboxId]) return '';
        if (value) return '';
        return detailCollectionValidation(gapCollection, formik, getName);
    }

    return (
        <>
            {detail.lookup_metadata?.map((lookup) => (
                <label className="me-3 mb-0" key={lookup.SupplementalDataValue}>
                    <Field
                        type="radio"
                        name={getName(detail)}
                        value={lookup.SupplementalDataValue}
                        validate={validate}
                    >
                        {({ field }: FieldProps) => (
                            <input
                                {...field}
                                type="radio"
                                id={`${getName(detail)}-${lookup.SupplementalDataValue}`}
                                disabled={readOnly || !formik.values[checkboxId]}
                                className="me-2"
                            />
                        )}
                    </Field>
                    {lookup.SupplementalDataValueDescription}
                </label>
            ))}
            <div className="text-danger">
                <ErrorMessage name={getName(detail)!} />
            </div>
        </>
    );
}
